import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import {JwtUtilService} from '../../core/jwt-util.service';
import {RestApiBase} from '../../shared/configurations/rest-api-base.config';
import {UrlUtils} from '../../shared/utils/url.utils';
import {ProfileService} from '../profile.service';


@Injectable({
    providedIn: 'root'
})
export class ProfileAwardsService {
    private http = inject(HttpClient);
    private jwtUtilService = inject(JwtUtilService);
    private profileService = inject(ProfileService);


    institutionCode: string;

    highlights = [];

    constructor() {
        this.institutionCode = UrlUtils.getParam('institution');
    }


    getAwards() {
        let params = new HttpParams().set('institution', this.institutionCode);
        if (this.profileService.isPublicPage){
            params = params.set('urlIdentifier', this.profileService.userID)
                .set('isUserLoggedIn', String(this.jwtUtilService.isLoggedIn()));
            return this.http.get(RestApiBase.GET_RESEARCHER_AWARDS_FOR_PUBLIC_PROFILE, {params: params});
        }
        params = params.set('userID', this.jwtUtilService.getUserID());
        return this.http.get(RestApiBase.GET_RESEARCHER_AWARDS, {params: params});
    }

    displayGrantOnPublicProfile(grantEntityId: string){
        const params = new HttpParams().set('institution', this.institutionCode);
        return this.http.put(RestApiBase.DISPLAY_GRANT_ON_PUBLIC_PROFILE, {'grantEntityId': grantEntityId, 'userID': this.jwtUtilService.getUserID()},
            {params: params});
    }

    hideGrantFromPublicProfile(grantEntityId: string){
        const params = new HttpParams().set('institution', this.institutionCode);
        return this.http.put(RestApiBase.HIDE_GRANT_FROM_PUBLIC_PROFILE, {'grantEntityId': grantEntityId, 'userID': this.jwtUtilService.getUserID()},
            {params: params});
    }

    addGrantHighlight(highlight){
        let params = new HttpParams();
        params = params.set('institution', this.institutionCode);
        return this.http.put(RestApiBase.ADD_GRANT_HIGHLIGHT, {'highlight': highlight, 'userID': this.jwtUtilService.getUserID()},
            {params: params});
    }

    removeGrantHighlight(highlight){
        const params = new HttpParams().set('highlight', highlight)
            .set('userID', this.jwtUtilService.getUserID())
            .set('institution', this.institutionCode);
        return this.http.delete(RestApiBase.REMOVE_GRANT_HIGHLIGHT, {params:params});
    }

}
